// Merge tags ("available words") offered when writing drip messages, and the helper that
// inserts one at the cursor of a textarea.

export const MERGE_TAGS = Object.freeze([
  { token: '#firstname#', label: 'First name' },
  { token: '#myagentname#', label: 'My name' },
  { token: '#mybookinglink#', label: 'Booking link' },
  { token: '#mybusinessphonenumber#', label: 'Business phone' },
  { token: '#company#', label: 'Company' },
]);

/**
 * Insert `token` into `value` at the caret/selection, adding a space where it would otherwise
 * butt up against a word.
 * @param {string} value
 * @param {string} token
 * @param {{start?: number, end?: number}} [sel] - Selection range; defaults to the end of the text.
 * @param {number} [max=1600]
 * @returns {{value: string, caret: number}} New text and where the caret should land.
 */
export function insertAtCaret(value, token, sel = {}, max = 1600) {
  const text = String(value || '');
  const start = Number.isInteger(sel.start) ? sel.start : text.length;
  const end = Number.isInteger(sel.end) ? sel.end : start;
  const before = text.slice(0, start);
  const after = text.slice(end);
  const lead = before && !/\s$/.test(before) ? ' ' : '';
  const trail = after && !/^\s/.test(after) ? ' ' : '';
  const insert = `${lead}${token}${trail}`;
  const next = `${before}${insert}${after}`;
  if (next.length > max) return { value: text, caret: start };
  return { value: next, caret: before.length + lead.length + token.length };
}
